import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetPositionsMappedToSalesforceOpportunityLineItemIdByOpportunityId } from './position';

export function getUsePositionsMappedToSalesforceOpportunityLineItemIdsKey(salesforceOpportunityId: string) {
    return ['positions', 'salesforceOpportunityId', salesforceOpportunityId];
}

export const usePositionsMappedToSalesforceOpportunityLineItemIds = (salesforceOpportunityId: string) => {
    const { getPositionsMappedToSalesforceOpportunityLineItemIdByOpportunityId } =
        useGetPositionsMappedToSalesforceOpportunityLineItemIdByOpportunityId();

    return useSuspenseQuery({
        queryKey: getUsePositionsMappedToSalesforceOpportunityLineItemIdsKey(salesforceOpportunityId),
        queryFn: () => getPositionsMappedToSalesforceOpportunityLineItemIdByOpportunityId({ salesforceOpportunityId }),
    });
};
